var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main",attrs:{"role":"main"}},[(_vm.uri !== '')?_c('iframe',{staticClass:"fixedmode",attrs:{"src":_vm.uri}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }